import React from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import DataGrid from "components/data-grid";
import ValidatedForm from "components/form";
import { validationSchema, defaultValues, handleSubmit, NewDeploymentForm } from "./forms/new-form";
import { useCurrentCustomerContext } from "components/current-customer-context";

const DeploymentNewPage = ({ intl, history }) => {
  const { currentCustomerId } = useCurrentCustomerContext();

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.deployment" />

      <PageSection>
        <ValidatedForm
          initialValues={defaultValues}
          validationSchema={validationSchema(intl)}
          onSubmit={handleSubmit({
            history,
            currentCustomerId,
          })}
        >
          {props => {
            return (
              <DataGrid>
                <NewDeploymentForm {...props} />
              </DataGrid>
            );
          }}
        </ValidatedForm>
      </PageSection>
    </Dashboard>
  );
};

export default DeploymentNewPage;
